export const connection: any = {
  setting: {},
  data: {},
  leadData: {},
  queryVariables: "$integrationId: String!, $customerId: String, $visitorId: String",
  queryParams: "integrationId: $integrationId, customerId: $customerId, visitorId: $visitorId",
  currentLanguage:'',
  enabledServices: {},
  browserInfo: {},
};
